import { useEffect } from "react";
import { useGetDefaultModelCapabilities } from "../AssistantServices";
import { useChatStore } from "../stores/ChatStore";

/**
 * Hook that fetches the default model capabilities (GeneralLLM) from the backend
 * and stores them in the ChatStore for use when no persona is selected.
 *
 * This should be called once at the app/page level to ensure default capabilities
 * are available for vision support checks.
 *
 * @example
 * // In a top-level component:
 * useDefaultModelCapabilities();
 */
export const useDefaultModelCapabilities = () => {
  const {
    data: capabilities,
    isLoading,
    isError,
  } = useGetDefaultModelCapabilities();
  const setDefaultSupportsVision = useChatStore(
    (state) => state.setDefaultSupportsVision,
  );

  useEffect(() => {
    if (capabilities && !isLoading && !isError) {
      setDefaultSupportsVision(capabilities.supports_vision ?? false);
    }
  }, [capabilities, isLoading, isError, setDefaultSupportsVision]);

  return {
    capabilities,
    isLoading,
    isError,
  };
};

export default useDefaultModelCapabilities;
